import React from "react";
import "./theme.css";
import styles from "./PageShell.module.scss";

const PageShell = ({
  title,
  titleAction,
  eyebrow,
  description,
  actions,
  actionsClassName = "",
  toolbar,
  children,
  className = "",
}) => {
  return (
    <section className={`${styles.shell} ${className}`}>
      <div className={styles.header}>
        <div className={styles.titleBlock}>
          {eyebrow ? <p className={styles.eyebrow}>{eyebrow}</p> : null}
          {title || titleAction ? (
            <div className={styles.titleRow}>
              {title ? <h1 className={styles.title}>{title}</h1> : null}
              {titleAction ? <div className={styles.titleAction}>{titleAction}</div> : null}
            </div>
          ) : null}
          {description ? (
            <p className={styles.description}>{description}</p>
          ) : null}
        </div>
        {actions ? <div className={`${styles.actions} ${actionsClassName}`.trim()}>{actions}</div> : null}
      </div>
      {toolbar ? <div className={styles.toolbar}>{toolbar}</div> : null}
      <div className={styles.content}>{children}</div>
    </section>
  );
};

export default PageShell;
